
/**
 * 输入内容格式化类型定义
 */
export enum FormatInputType {
  /** cdKey兑换码 */
  cdKey = 'cdKey',
  /** 银行卡 */
  cardNum = 'cardNum',
  /** 默认，不做任何格式化处理 */
  defalut = 'defalut'
}

interface FormatConfigItem {
  type: string;
  format: {
    input: (value: string) => string,
    output: (value: string) => string
  }
}

/** 格式化配置 */
const inputFormatConfig: { [v: string]: FormatConfigItem } = {
  [FormatInputType.defalut]: {
    type: 'text',
    format: {
      input: (value: string) => value,
      output: (value: string) => value,
    },
  },
  [FormatInputType.cdKey]: {
    type: 'text',
    format: {
      /** 每4位用空格隔开 */
      input: (value: string) => value.replace(/[\s ]+/g, '').replace(/(.{4})/g, '$1 ')
        .trim(),
      /** 去掉空格 */
      output: (value: string) => value.replace(/[\s ]+/g, ''),
    },
  },
  [FormatInputType.cardNum]: {
    type: 'number',
    format: {
      /** 每4位用空格隔开 */
      input: (value: string) => value.replace(/[\s ]+/g, '').replace(/(.{4})/g, '$1 ')
        .trim(),
      /** 去掉空格 */
      output: (value: string) => value.replace(/[\s ]+/g, ''),
    },
  },
};

export default inputFormatConfig;
